// Brand Config — reads brand-specific values from data attributes on <body>.
//
// Rails injects data-brand-* attributes via RebrandHelper, making brand values
// available to JS without hardcoding. When the rebrand flag is off, old-brand
// values are injected; when on, new-brand values appear automatically.
//
// Usage:
//   import { brandConfig } from "lib/brand_config";
//   const email = brandConfig("supportEmail");
//
// Falls back gracefully if the attribute is missing (returns undefined),
// so JS components won't break if loaded before the body is parsed.

const brandConfig = (key) => {
  if (typeof document === "undefined") return undefined;
  const { body } = document;
  if (!body) return undefined;
  return body.dataset[`brand${key.charAt(0).toUpperCase()}${key.slice(1)}`];
};

module.exports = { brandConfig };
